import TaskSelect from './TaskSelect-container';

export default TaskSelect;
